import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonModify, ManageButton } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import AvailibilityCalendar from './components/availability-calendar';
import Banner from './components/banner';
import InputsCounter from '../../components/inputs/inputs-counter';
import coWorkingApi from '../../lib/co-working/co-working-api';
import Blurred from '../../components/blurred';
import { datetimeLocalToString } from '../../lib/helpers/datetime-helpers';
import _ from 'lodash';
import dayjs from 'dayjs';
import LabelContainer from '../../components/label-container';
import Scrollable from '../../components/scrollable';
import LatestUpdates from '../dashboard/components/component-latest-updates';
import RenderThisIf from '../../components/renderIf';
import auth from '../../lib/users/auth';
import { COMPANY_BOOK_CO_WORKING_SPACES } from '../../utils/permissions';

class CoWorkingIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spaces: [],
            params: {
                no_attendees: 1,
                day: null,
            },
            selectedMonth: new Date(),
            bookings: []
        }
    }

    componentDidMount() {
        this.fetchSpaces();
        this.getMonthAvailability();
    }

    fetchSpaces() {
        coWorkingApi.getCoWorkingSpaces().then(({ data }) => {
            this.setState({ spaces: data })
        })
    }

    fetchSpace() {
        coWorkingApi.getCoWorkingSpace(this.state.params.space).then(({ data }) => {
            this.setState({ space: data })
        })
    }

    onChange(e, callback = () => {}) {
        let params = { ...this.state.params }

        params = {
            ...params,
            ...e
        }

        this.setState({ params }, callback);
    }

    onAttendeesChange(e) {
        this.onChange({
            no_attendees: e
        }, () => {
            this.getMonthAvailability();
        })
    }

    onDaySelect(date) {
        this.onChange({
            day: date,
        });
    }

    getMonthAvailability = _.debounce(() => {
        this.onChange({ day: null });

        coWorkingApi.getIndexBookingMonthAvailability({
            start_of_month: datetimeLocalToString(dayjs(this.state.selectedMonth).startOf('month')),
            no_attendees: this.state.params?.no_attendees
        }).then(({ data }) => {
            this.setState({ 
                bookings: data
            });
        });
    }, 500, false);

    getTimeOfDay() {
        const sessions = this.state.bookings?.[this.state?.params?.day]?.sessions_available;

        let from = `Nothing Selected`;

        if (sessions === 'morning') {
            from = 'Morning'
        }
    
        if (sessions === 'afternoon') {
            from = 'Afternoon'
        }
    
        if (sessions === 'day') {
            from = 'All Day'
        }

        return from;
    }

    newBooking() {
        const day = this.state.bookings?.[this.state?.params?.day];
        const sessions = day?.sessions_available;
        const date = this.state.params?.day;
        const no_attendees = this.state.params?.no_attendees;
        const space = day?.space_id_available;

        const url = new URL(`${window.location.origin}/mydmc/co-working/bookings/new`);
        
        url.searchParams.append('day', date);
        url.searchParams.append('no_attendees', no_attendees);
        url.searchParams.append('sessions', sessions);
        url.searchParams.append('space', space);

        window.location.href = url.href;
    }

    render() {
        return (
            <Layout 
                theme="dark"
                className="coworking-index"
                topLeft={<Welcome seam title="Welcome to" subtitle="Co-Working"/>}
                topRight={
                    <Row gap="20px">
                
                    </Row>
                }
            >
                <List gap='40px'>
                    <Banner/>
                    <SeventyThirtyLayout
                        main={
                            <RenderThisIf
                                renderIf={auth.hasPermission(COMPANY_BOOK_CO_WORKING_SPACES) || auth.isOwnerOrManager()}
                                render={
                                    <Container>
                                        <Container.Header>
                                            <Row gap="20px">
                                                <Container.Icon src="/assets/icons/trophy.svg"/>
                                                <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Availability</Container.Text>
                                            </Row>
                                        </Container.Header>

                                        <Container.Content>
                                            <List gap="40px">
                                                <AvailibilityCalendar 
                                                    bookings={this.state.bookings}
                                                    onDaySelect={this.onDaySelect.bind(this)}
                                                    handleViewChange={(data) => {
                                                        this.setState({
                                                            selectedMonth: data?.activeStartDate,
                                                        }, () => {
                                                            this.getMonthAvailability();
                                                        })
                                                    }}
                                                />

                                                <Row gap="40px" justifyContent="space-between" className="coworking-index__attendees">
                                                    <List gap="20px">
                                                        <InputsCounter
                                                            label="Number Of Attendees"
                                                            min={0}
                                                            onChange={this.onAttendeesChange.bind(this)}
                                                            value={this.state.params?.no_attendees}
                                                        />

                                                        { this.state.params?.day !== null && <LabelContainer label="Booking Date & Duration">
                                                            { dayjs(this.state.params?.day).format('DD/MM/YYYY') } - { this.getTimeOfDay() }
                                                        </LabelContainer> }
                                                    </List>

                                                    <Blurred toggled={this.state.params?.day === null}>
                                                        <ButtonModify onClick={this.newBooking.bind(this)}>Book for this selection</ButtonModify>
                                                    </Blurred>
                                                </Row>
                                            </List>
                                        </Container.Content>
                                    </Container>
                                }
                            />
                        }
                        sectionOne={
                            {
                                name: 'Side',
                                component: (
                                    <Container>
                                        <Container.Header>
                                            <Row gap="20px">
                                                <Container.Icon src="/assets/icons/trophy.svg"/>
                                                <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Latest DMC Updates</Container.Text>
                                            </Row>
                                        </Container.Header>

                                        <Container.Content>
                                            <LatestUpdates/>
                                        </Container.Content>
                                    </Container>
                                )
                            }
                        }
                    />
                </List>
            </Layout> 
        )
    }
}

const el = document.getElementById('coworking-index');

if (el) {
    ReactDOM.render(
        <CoWorkingIndex/>   
    , el);
}
